export default "__VITE_ASSET__DG2iHa83__"